export const config = {
    //apiUrl: process.env.REACT_APP_API_URL ?? "https://dev.v-winapp.com",
    apiUrl: process.env.REACT_APP_API_URL ?? "https://app.v-winapp.com",
};
